// import 'font-awesome/css/font-awesome.css';
import './scss/main.scss';

import angular from 'angular';
import 'angular-translate';
import 'angular-moment';
import 'angular-i18n/angular-locale_it-it';
import 'angular-translate-loader-partial';
import 'angular-animate/angular-animate.js';
import 'angular-http-auth';
//import './vendors/angular-http-auth.js';
import 'angular-datepicker';
import 'angular-jwt';
import 'angular-base-apps/dist/js/base-apps.js';
import 'angular-base-apps/dist/js/base-apps-templates.js';
import 'ng-img-crop-full-extended/compile/unminified/ng-img-crop.js';
import 'ngmap/build/scripts/ng-map.debug.js';
import './vendors/angular-ui-swiper/angular-ui-swiper.js';
//import Framework from 'tinaba-framework';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import Constants from './constants/env';
import moment from 'moment';
import providers from './common/services/tinaba-framework/providers';



window.Tether = require('tether');

function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
}

requireAll(require.context('./translations', true, /\.json$/));

angular.module('tinaba', [
    'ui.router',
    'ngAnimate',
    'ngMap',
    // 'foundation',
    // 'foundation.dynamicRouting',
    // 'foundation.dynamicRouting.animations',
    'base',
    'base.dynamicRouting',
    'base.dynamicRouting.animations',
    'datePicker',
    'ngImgCrop',
    'http-auth-interceptor',
    'translations',
    'angularMoment',
    'angular-jwt',
    providers.name,
    Common.name,
    Components.name,
    //Framework.name,
    Constants.name,
    'ui.swiper'
])

    .config(($urlRouterProvider, $translateProvider, $sceDelegateProvider, EnvironmentProvider, envName, endPoints, uiConfig) => {
        'ngInject';
        // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
        // #how-to-configure-your-server-to-work-with-html5mode
        // $locationProvider.html5Mode(true).hashPrefix('!');

        $translateProvider.preferredLanguage('it_IT');
        $urlRouterProvider.otherwise('/dashboard/main');
        $sceDelegateProvider.resourceUrlWhitelist(['**']);
        EnvironmentProvider.setEnvName(envName);
        EnvironmentProvider.setEndPoints(endPoints);
        EnvironmentProvider.setUiConfig(uiConfig);
        moment.locale('it');
        // Disbale console error for production environment
        if (envName === 'pro') {
            if (!window.console) window.console = {};
            const methods = ['log', 'debug', 'warn', 'info', 'table', 'error'];
            for (let i = 0; i < methods.length; i = i + 1) {
                console[methods[i]] = () => {
                };
            }
        }
    })

    .component('app', AppComponent)

    .run(($log, $rootScope, $state, $timeout, $interval,
          $translate, $location, authService, envName,
          FoundationApi, LoginService, ModalFactory,
          NewUiService, pathSuperAdmin, StorageService,
          NewTokenService, scaTypeConstants) => {
        'ngInject';

        var modal;
        var loopHandler = {};
        var loopAuthenticationDetected = false;
        var isUpdating = false;

        var promise = $interval(NewTokenService.checkLogout, 1000);

        let loginModalOpen = false;

        const closeModal = modal => {
            modal.deactivate();
            loginModalOpen = false;
            $timeout(() => {
                modal.destroy();
            }, 1000);
        };

        const openLoginModal = () => {
            if (loginModalOpen) return;
            loginModalOpen = true;

            FoundationApi.closeActiveElements();

            modal = new ModalFactory({
                class: 'tiny',
                overlay: true,
                overlayClose: false,
                template: '<login on-login-completed="close()"></login>',
                contentScope: {
                    close: () => closeModal(modal)
                }
            });

            modal.activate();
        };

        const goToLogin = path => {
            if (MODE == "admin") {
                $state.go('listaMerchantSuperAdmin');
                return;
            }
            const userContext = NewTokenService.getUserContext();
            if ($location.url() === pathSuperAdmin || StorageService.getLocalStorage('superAdmin') === 'true' || (userContext !== undefined && userContext.superAdmin)) {
                $state.go('listaMerchantSuperAdmin');
            } else if (envName === 'dev' || envName === 'col' || envName === 'col-r2' || envName === 'dev-r2' || envName === 'pro-r2') {
                openLoginModal();
            } else {
                let redirectUrl = `${window.location.protocol}//${window.location.host}`;
                if (path) {
                    redirectUrl += `/${path}`;
                }

                window.location = redirectUrl;
            }
        };

        $rootScope.$on('event:auth-loginRequired', () => {
            if (isUpdating || loopAuthenticationDetected) return;

            isUpdating = true;
            LoginService.renewToken().then(() => {
                isUpdating = false;
                authService.loginConfirmed('success', function(config){
                    config.headers["Authorization"] = "Bearer "+StorageService.getLocalStorage("access_token");
                    return config;
                })
            }, () => {
                isUpdating = false;
                LoginService.softLogout();
                goToLogin();
            });
        });

        //preventLoopAuthentication
        $rootScope.$on('event:auth-loginRequired', (event, call) => {
            const key = call.data.path || call.config.url;
            if (!loopHandler[key]) {loopHandler[key] = 0;}
            loopHandler[key] = loopHandler[key]+1;

            if (loopHandler[key] >= 5) {
                loopAuthenticationDetected = true;
                alert("Si è verificato un errore. Se il problema persiste contattare il servizio clienti Tinaba", "Attenzione");
                setTimeout(() => {
                    LoginService.softLogout();
                    goToLogin();
                }, 10000);
            }

            $timeout(() => {
                loopHandler[key] = 0;
                loopAuthenticationDetected = false;
            }, 10000);
        });


/*
        $rootScope.$on('event:auth-loginRequired', () => {   
            authService.loginCancelled();
            if ($location.url() !== pathSuperAdmin && StorageService.getLocalStorage('superAdmin') !== 'true') {
                LoginService.softLogout();
                goToLogin();
            } else {
                $state.go('listaMerchantSuperAdmin');
            }    
        });


        $rootScope.$on('event:auth-renewTokenRequired', () => {
            LoginService.renewToken().then(() => {
                authService.loginConfirmed('success', function(config){
                    config.headers["Authorization"] = "Bearer "+StorageService.getLocalStorage("access_token");
                    return config;
                })
            }, () => {
                authService.loginCancelled();
                if ($location.url() !== pathSuperAdmin && StorageService.getLocalStorage('superAdmin') !== 'true') {
                    LoginService.softLogout();
                    goToLogin();
                } else {
                    closeModal(modal)
                    $state.go('listaMerchantSuperAdmin');
                    $rootScope.$broadcast('event:auth-superLoginRequired')
                }
            });
        });
*/
        $rootScope.$on('messages:addError', (event, data) => {
            FoundationApi.publish('notifications', {
                color: 'alert',
                title: $translate.instant('common.error'),
                content: NewUiService.parseErrorMessage(data.message),
                autoclose: 10000
            });
        });

        $rootScope.$on('messages:addSuccess', () => {
            FoundationApi.publish('notifications', {
                color: 'success',
                title: $translate.instant('common.info'),
                content: $translate.instant('common.infos.success'),
                autoclose: 5000
            });
        });

        $rootScope.$on('doLogout', () => {
            LoginService.softLogout();
            goToLogin();
        });

        $rootScope.$on('logoutTimeout', () => {
            //LoginService.logout().then(() => {
                goToLogin();
                FoundationApi.publish('notifications', {
                    color: 'alert',
                    title: $translate.instant('login.errors.session.title'),
                    content: $translate.instant('login.errors.session.body'),
                    autoclose: 10000
                });
            //});
        });

        $rootScope.$on('USER_LOGGED_OUT', () => goToLogin());

        $rootScope.$on('$stateChangeStart', (event, toState) => {
            if (toState.redirect) {
                event.preventDefault();
                $state.go(toState.redirect);
                return;
            }
        });

        LoginService.checkCachedProfile();
});



/** WEBPACK FOOTER **
 ** ./client/app/app.js
 **/